import { FilterChip, useQueryParams } from '@marqvision/shared';
import { useLogger } from '~/hooks';
import { useTab } from '~/pages/DomainNames/@hooks/useTab';
import { FilterQueryParams } from '~/pages/DomainNames/@types';

export const FaviconFilter = () => {
  const { currentTabGroup } = useTab();
  const { amplitudeLogging } = useLogger();

  const { params, setParams, removeParams } = useQueryParams<FilterQueryParams>();

  const isSelected = Boolean(params.favicon_detected_filter);

  const handleToggle = () => {
    amplitudeLogging('applied filter', {
      Type: 'favicon detected',
      Channel: 'domain names',
      Page: currentTabGroup.replace(/-/g, ' '),
    });

    if (isSelected) {
      removeParams('favicon_detected_filter');
    } else {
      setParams({ favicon_detected_filter: true }, { replace: true });
    }
  };

  return <FilterChip type="toggle" label="Favicon detected" selected={isSelected} onClick={handleToggle} />;
};
